import angular from 'angular';

import component from './starRatings.component';
import Listing from '../listing/index';
import SellerData from '../sellerData';
import NgUser from 'cars-ng-user';
import NgBrowser from 'cars-ng-browser';


export default angular.module('starRatings.shared.starRatings', [
    /* your module dependencies go here */
    Listing,
    SellerData,
    NgBrowser,
    NgUser,
    'cars.ui.angular'
])

.component('carsStarRatings', component)

.name;
